import { useTranslation } from "@/hooks/useTranslation"
import { DatePickerExportContainer } from "@/organisms/DatePickerExportContainer/DatePickerExportContainer"
import { Filter } from "@/organisms/FilterNew/Filter"
import { InputSmartSearchLoading, SmartSearch } from "@/organisms/SmartSearch"
import { useFiltersScanHistory } from "@/pages/GovernancePage/applications/scan-history/useScanHistory"
import { FilterScanHistoryTabProps } from "./FilterScanHistoryTab.types"

export const FilterScanHistoryTab = (props: FilterScanHistoryTabProps) => {
  const placement = "FilterScanHistory"
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.scanHistory.filters"
  })
  const { response, isLoading } = useFiltersScanHistory()
  const data = response?.data
  const filters = data?.all
  const policyResultOptions = data?.policyResult.options
  const scanTypeOptions = data?.scanType.options
  const policyExceptionStatusOptions = data?.policyExceptionStatus?.options

  return (
    <Filter.Provider isLoading={isLoading}>
      <Filter.Template
        isLoading={isLoading}
        search={
          isLoading ? (
            <InputSmartSearchLoading />
          ) : (
            <SmartSearch id="FilterScanHistory" filters={filters} />
          )
        }
        aside={
          <DatePickerExportContainer
            isLoading={isLoading}
            exportType="ScanHistory"
            placement={placement}
            pickerType="rangePicker"
            disableExport={!props.hasData}
          />
        }
      >
        <Filter.Checkbox
          keyFilter="scanType"
          items={scanTypeOptions}
          placeHolderDefaultValue={t("scanType")}
          isLoading={isLoading}
          placement={placement}
          order="asc"
        />
        <Filter.Checkbox
          keyFilter="policyResult"
          items={policyResultOptions}
          placeHolderDefaultValue={t("policyResult")}
          isLoading={isLoading}
          placement={placement}
          order="asc"
        />
        {policyExceptionStatusOptions && (
          <Filter.CountedCheckbox
            keyFilter="policyExceptionStatus"
            items={policyExceptionStatusOptions}
            placeHolderDefaultValue={t("policyException")}
            isLoading={isLoading}
            placement={placement}
            order="none"
          />
        )}
      </Filter.Template>
    </Filter.Provider>
  )
}
